import React, { useState } from "react";
import peliculas from "../db.json";
import Tarjeta from "../components/Tarjeta";
import estilo from "../styles/Inicio.module.css";
import Titulos from "../components/Titulos";
import Estrenos from "../components/Estrenos";
import Recomendadas from "../components/Recomendadas";
import MetaDecorator from "../utils/MetaDecorator";

function Inicio() {
  //
  const series = peliculas
    .map(({ ...capitulos }) => ({ ...capitulos }))
    .filter((e) => e.tipo === "serie");
  //
  const pelis = peliculas
    .map(({ ...capitulos }) => ({ ...capitulos }))
    .filter((e) => e.tipo === "pelicula");
  //
  const [elementoPagina] = useState(1);
  const [elementosPorPagina] = useState(6);
  const ultimoIndice = elementoPagina * elementosPorPagina;
  const primerIndice = ultimoIndice - elementosPorPagina;
  //
  const elementosSalidaPelis = pelis.slice(primerIndice, ultimoIndice);
  const elementosSalidaSeries = series.slice(primerIndice, ultimoIndice);
  return (
    <div className={estilo.peliculas}>
      <MetaDecorator
        titulo={"RepelisPlus"}
        subtitulo={"RepelisPlus"}
        descripcion={
          "Las mejores peliculas las encuentras en RepelisPlus, peliculas de estreno en alta calidad gratis."
        }
      />
      <div className={estilo.linea}></div>
      <Estrenos></Estrenos>

      <Titulos titulo="Ultimas Series" tipo="series"></Titulos>
      <div className={estilo.grid_peliculas}>
        {elementosSalidaSeries.map((e) => (
          <Tarjeta key={e.id} pelicula={e}></Tarjeta>
        ))}
      </div>

      <Titulos titulo="Ultimas Peliculas" tipo="peliculas"></Titulos>
      <div className={estilo.grid_peliculas}>
        {elementosSalidaPelis.map((e) => (
          <Tarjeta key={e.id} pelicula={e}></Tarjeta>
        ))}
      </div>

      <Titulos titulo={"Peliculas Recomendadas"}></Titulos>
      <Recomendadas></Recomendadas>
      <br></br>
    </div>
  );
}

export default Inicio;
